export const COLOR_BLINK_ANIMATION_TIMEOUT = 1300; // также менть в ./_color.scss
